const initial = (name) => (name ? name.charAt(0).toUpperCase() : '');

const getInitials = (lastName, firstName) => `${initial(firstName)}${initial(lastName)}`;

export default getInitials;
